import { cleanContent } from 'common/utils/cleanContent';
import Burst12 from './shapes/Burst12';
import Circle from './shapes/Circle';
import Diamond from './shapes/Diamond';
import Oval from './shapes/Oval';
import useStyles from './styles/useStylesPosters.styles';

const Poster = (props) => {
    const { shapeId, color, scale, text, size } = props;

    const { classes } = useStyles();

    let rootClass = classes.root;

    if (size === 'big') {
        rootClass += ` ${classes.sizeBig}`;
    }

    if (size === 'small') {
        rootClass += ` ${classes.sizeSmall}`;
    }

    const getShape = () => {
        const shapeColor = color ? color : '#b3b3b3';
        switch (shapeId) {
            case 'oval':
                return <Oval color={shapeColor} />;

            case 'circle':
                return <Circle color={shapeColor} />;

            case 'diamond':
                return <Diamond color={shapeColor} />;

            case 'burst12':
                return <Burst12 color={shapeColor} />;

            default:
                return null;
        }
    };

    return (
        <div className={rootClass} style={{ transform: scale ? `scale(${scale})` : 'none' }}>
            {getShape()}
            {text && (
                <div className={classes.textContainer}>
                    <div dangerouslySetInnerHTML={{ __html: cleanContent(text) }} />
                </div>
            )}
        </div>
    );
};

export default Poster;
